import { RESULT_COUNT_CAP } from '../globalSearch.constants';

const isResultCountCapped = (total: number): boolean => total >= RESULT_COUNT_CAP;

export const formatResultCount = (total: number): string | number =>
  isResultCountCapped(total) ? `${RESULT_COUNT_CAP}+` : total;
